import { Controller } from "@hotwired/stimulus"

// MS50 #3003 — CSP-safe print trigger.
//
// Replaces inline `onclick="window.print()"` / nonce-less inline print functions
// the enforcing nonce CSP (#1222) blocked. Wire with
// `data-controller="print"` and `data-action="click->print#print"`.
export default class extends Controller {
  print(event) {
    event.preventDefault()
    window.print()
  }
}
